import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import { Card, Button } from "antd"
import { LogoutOutlined } from "@ant-design/icons"

import { Footer } from "@components/Page"
import { getConfig } from "@components/Config"
import { OrganizationsList } from "@components/Organization"

import ReportsList from "../reports/ReportsList"

const PLATFORM_NAME = getConfig("PLATFORM_NAME")

const LABEL_TITLE = "Console"
const LABEL_SIGNOUT = "Sign Out"
const LABEL_REPORTS = "Reports"
const LABEL_ORGANIZATIONS = "Organizations"

const LOGOUT_PATH = "/logout/backstage"

const tabList = [
  {
    key: "organizations",
    tab: LABEL_ORGANIZATIONS,
  },
  {
    key: "reports",
    tab: LABEL_REPORTS,
  },
];


const ConsoleManagerPage = () => {
  const [ activeTabKey, onTabChange ] = useState("organizations");

  const navigate = useNavigate()

  const extra =
    <Button
      type="text"
      size="small"
      icon={<LogoutOutlined />}
      onClick={() => navigate(LOGOUT_PATH)}
    >
      {LABEL_SIGNOUT}
    </Button>

  const cardProps = {
    title: LABEL_TITLE,
    tabProps: { size: "middle" },
    extra,
    tabList,
    activeTabKey,
    onTabChange,
  }

  const renderContent = () => (
    {
      organizations: <OrganizationsList />,
      reports: <ReportsList span={24} />,
    }[activeTabKey]
  )

  return (
    <>
      <Card {...cardProps}>
        {renderContent()}
      </Card>

      <Footer organizationName={PLATFORM_NAME} />
    </>
  )
}

export default ConsoleManagerPage
